<template>
  <q-page padding>
    <!-- <base-form :resource="$route.meta.resource" :id="this.$route.params.id" /> -->
    <user-edit></user-edit>
  </q-page>
</template>

<script>
import UserEdit from '../../../components/custom/userEdit'

export default {
  inject: ['$validator'],
  name: 'EditForm',
  components: {UserEdit}
}
</script>

<style>
</style>
